module.exports = __webpack_public_path__ + "img/11.321f5c9d.jpg";